/**
 * Environment detection utilities for metrics
 * Determines correct CTI based on script URL and page hostname
 */

import { CTI } from "@amzn/exs-client-logging/v2";

// If the script is loaded from these domains, or loaded in these domains, use the gamma CTI
const GAMMA_HOSTNAMES = [
  "cpf-gamma.tuxedo.prod.barossa.dubai.aws.dev",
  "localhost",
];

const CTI_PROD: CTI = "CPFElement";
const CTI_GAMMA: CTI = "CPFElementGamma";

/**
 * Determines the correct CTI based on script URL and page hostname
 * @param importUrl - The import.meta.url of the current module
 * @returns The appropriate CTI for the current environment
 */
export const getCTIFromScriptUrl = (importUrl: string): CTI => {
  try {
    const scriptUrl = new URL(importUrl);

    // Check both script URL hostname and page hostname for gamma detection
    const isGamma =
      GAMMA_HOSTNAMES.includes(scriptUrl.hostname) ||
      (typeof window !== "undefined" &&
        GAMMA_HOSTNAMES.some((hostname) =>
          window.location.hostname.includes(hostname),
        ));

    return isGamma ? CTI_GAMMA : CTI_PROD;
  } catch (error) {
    console.warn(
      "Failed to determine CTI from script URL, defaulting to production CTI:",
      error,
    );
    return CTI_PROD;
  }
};
